import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { RktIconComponent } from '@rocketfinancialcorp/rocket-ui/icon';

import { toTitleCase } from '@shared/utils';

import { NotAvailablePipe } from '../../../pipes/not-available.pipe';
import { PhonePipe } from '../../../pipes/phone.pipe';
import { DetailsItemComponent } from '../../details-item/details-item.component';
import { TextWithPlaceholderComponent } from '../../text-with-placeholder/text-with-placeholder.component';

@Component({
  selector: 'app-summary-info',
  templateUrl: './summary-info.component.html',
  styleUrls: ['./summary-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TextWithPlaceholderComponent, DetailsItemComponent, RouterLink, TitleCasePipe, PhonePipe, NotAvailablePipe, RktIconComponent],
})
export class SummaryInfoComponent {
  @Input() user!: Partial<{
    name: string;
    businessContactName: string;
    phoneNumber: string;
    email: string;
    address: string;
    sex: string;
  }> | null;

  @Input() isCounterparty = false;

  @Input() isLoading = false;

  @Input() customerType?: string;

  get userGender() {
    return this.user?.sex === 'NONBINARY' ? 'Non-Binary' : toTitleCase(this.user?.sex);
  }

  get isBusinessCustomer() {
    return this.customerType === 'business';
  }
}
